import { hostUrl, ogwHostUrl } from '@telstra-connect/utils/http/constants';

export const getDashboardFlags = () => (global.applications && global.applications.Platform);

export interface IOGWConfig {
    ogw_enabled: boolean;
    ogw_paths: IOGWPaths;
}

interface IOGWPaths {
    enableApplicationPath: string[];
    excludePathsSegments: string[];
    includePathsSegments: string[];
}

const isValuePresent = (url: string, parts: string[]) => {
    return parts.some((part: string) => url.includes(part));
}

const isOGWEnabled = () => {
    const ogwConfig = getDashboardFlags()?.ogwConfig;
    return ogwConfig && ogwConfig.ogw_enabled;
}

const isApplicationPathResoved = (url: string) => {
    const enableApplicationPath = getDashboardFlags()?.ogwConfig.ogw_paths?.enableApplicationPath;
    return enableApplicationPath && enableApplicationPath.length > 0 && isValuePresent(url, enableApplicationPath);
}

const inIncludePathSegment = (url: string) => {
    const includePathsSegments = getDashboardFlags()?.ogwConfig.ogw_paths?.includePathsSegments;
    return includePathsSegments && includePathsSegments.length > 0 && isValuePresent(url, includePathsSegments);
}

const inExcludePathSegment = (url: string) => {
    const excludePathsSegments = getDashboardFlags()?.ogwConfig.ogw_paths?.excludePathsSegments;
    return excludePathsSegments && excludePathsSegments.length > 0 && isValuePresent(url, excludePathsSegments);
}

export const resolveTargetURL = (url: string) => {
    if (isOGWEnabled()
        && (isApplicationPathResoved(url) || inIncludePathSegment(url))
        && !inExcludePathSegment(url)) {
        return ogwHostUrl;
    } else {
        return hostUrl;
    }
}
